import { Select } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import { useSyncData } from "~/compositions/state.js";
import { $t } from "~/i18n.js";
import { useClub } from "./ClubContext.jsx";
import { ClubOptionLabel } from "./ClubOptionLabel.jsx";

const DTOclubSelector = () => {
  const history = useHistory();
  const { selectedDTOClub, setSelectedDTOClub, clubs, loadingClubs } =
    useClub();
  const { updateBase } = useSyncData();
  const { club } = useSelector((state) => state.persist);

  if (!club.is_association) {
    return null;
  }

  const selectClub = async (value) => {
    history.push(value ? "/members" : "/");
    setSelectedDTOClub(value);
    window.selectedDTOClub = value;
    await updateBase();
  };

  return (
    <div style={{ marginRight: 24 }}>
      <Select
        showSearch
        value={selectedDTOClub || ""}
        placeholder={$t("DTO club selector")}
        onChange={selectClub}
        loading={loadingClubs}
        style={{ minWidth: 250 }}
        optionFilterProp="children"
        filterOption={(input, option) => {
          // Use option.label for filtering (Ant Design v4+)
          const label = option.label ? option.label.toString() : "";
          return label.toLowerCase().includes(input.toLowerCase());
        }}
      >
        <Select.Option key="deselect" value={""} label={club.full_name}>
          {$t("Terug")} ({club.full_name})
        </Select.Option>

        {clubs.map((club) => (
          <Select.Option
            key={club.schema_name}
            value={club.schema_name}
            label={club.full_name}
          >
            <ClubOptionLabel club={club} />
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default DTOclubSelector;
